<div class="bell-wrap">
  <button
    type="button"
    class="bell-button"
    (click)="toggleDropdown()"
    [title]="'AlertsAlerts' | t"
    [attr.aria-label]="'AlertsAlerts' | t"
  >
    <i class="fa-solid fa-bell"></i>
    <span
      class="bell-badge"
      *ngIf="openCount > 0"
      [class.bell-badge-critical]="hasCritical"
    >
      {{ openCount > 99 ? '99+' : openCount }}
    </span>
  </button>

  <div class="bell-dropdown" *ngIf="dropdownOpen">
    <div class="bell-dropdown-header">
      <span>{{ 'AlertsAlerts' | t }}</span>
      <span class="bell-open-count" *ngIf="openCount > 0">{{ openCount }} open</span>
    </div>

    <div class="bell-loading" *ngIf="loadingAlerts">{{ 'NotificationsLoading' | t }}</div>

    <div class="bell-empty" *ngIf="!loadingAlerts && recentAlerts.length === 0">
      <i class="fa-solid fa-circle-check"></i>{{ 'NotificationsNoOpenAlerts' | t }}</div>

    <div class="bell-alert-list" *ngIf="!loadingAlerts && recentAlerts.length > 0">
      <div
        class="bell-alert"
        [class.bell-alert-clickable]="canOpenAlert(alert)"
        [attr.role]="canOpenAlert(alert) ? 'link' : null"
        [attr.tabindex]="canOpenAlert(alert) ? 0 : null"
        [attr.title]="canOpenAlert(alert) ? 'Open ' + alert.projectName : null"
        (click)="openAlertProject(alert)"
        (keydown.enter)="openAlertProject(alert)"
        (keydown.space)="openAlertProject(alert)"
        *ngFor="let alert of recentAlerts">
        <i class="fa-solid {{ severityIcon(alert) }} bell-alert-icon sev-{{ alert.severity }}"></i>
        <div class="bell-alert-body">
          <div class="bell-alert-title">
            {{ alert.projectName }}
            <span class="bell-alert-device">{{ alert.deviceSerial }}</span>
          </div>
          <div class="bell-alert-message">{{ alert.message }}</div>
          <div class="bell-alert-time">{{ alert.lastSeenAt | vcDate: 'minutes' }}</div>
        </div>
        <button
          type="button"
          class="bell-ack-button"
          [title]="'NotificationsAcknowledge' | t"
          (click)="acknowledge(alert, $event)"
        >{{ 'AlertsAck' | t }}</button>
      </div>
    </div>

    <div class="bell-dropdown-footer">
      <a routerLink="/alerts" (click)="dropdownOpen = false">{{ 'NotificationsViewAll' | t }}</a>
    </div>
  </div>
</div>
